import RoomLayout from "/components/shared/layouts/RoomLayout";
import RoomBox from "/components/shared/layouts/RoomBox";
import ViewHeader from "/components/shared/ViewHeader.jsx";

export default function Impressum() {

    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
            <RoomBox style='mt-24 p-4'>
                <ViewHeader title="zum foyer" url="/foyer"/>
                <div className='text-sm xl:text-base mt-6 flex items-center justify-center'>
                    <p>

                        <h1>DATENSCHUTZERKLÄRUNG</h1>

                        <p>Name und Kontaktdaten des für die Verarbeitung Verantwortlichen. Diese
                            Datenschutz-Information gilt für die Datenverarbeitung durch:</p>

                        <p>
                            Junges Theater Bonn e.V.<br/>
                            Hermannstr. 50<br/>
                            53225 Bonn-Beuel<br/>
                        </p>

                        <div className="pt-3">
                            <a
                                className={`underline bg-gold rounded-lg px-3 py-1 font-bold text-white uppercase flex justify-center items-center cursor-pointer w-max`}
                                href="https://www.jt-bonn.de/unternehmen/datenschutzbestimmungen/">zu den
                                Datenschutzbestimmungen des Jungen Theater Bonn</a>
                        </div>
                    </p>
                </div>
            </RoomBox>
        </RoomLayout>
    );
}

